// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".leftform-customer-type[data-v-435addf3]{position:relative}.leftform-customer-type .customer-type[data-v-435addf3]{position:absolute;left:-14px;top:3px;font-weight:bolder;font-size:16px;white-space:nowrap}", ""]);
// Exports
module.exports = exports;
